import { useCallback, useRef } from 'react';
import { Link } from 'react-router-dom';
import useCookieConsent from '../hooks/useCookieConsent';
import useFocusTrap from '../hooks/useFocusTrap';

const CookieBanner = () => {
  const { status, accept, decline } = useCookieConsent();
  const bannerRef = useRef(null);
  const isVisible = status === null;
  const noop = useCallback(() => {}, []);

  useFocusTrap(bannerRef, isVisible, noop);

  if (!isVisible) return null;

  return (
    <div
      className="cookie-banner"
      role="dialog"
      aria-modal="true"
      aria-label="Cookie consent"
      ref={bannerRef}
      tabIndex={-1}
    >
      <div className="cookie-banner__inner">
        <div className="cookie-banner__text">
          <p className="cookie-banner__title">We use cookies</p>
          <p className="cookie-banner__body">
            We use essential cookies to keep the site working. We'd also like to
            use analytics cookies to understand how you use it.{' '}
            <Link to="/privacy-policy" className="cookie-banner__link">
              Privacy Policy
            </Link>
          </p>
        </div>
        <div className="cookie-banner__actions">
          <button
            className="cookie-banner__btn cookie-banner__btn--decline"
            onClick={decline}
          >
            Decline
          </button>
          <button
            className="cookie-banner__btn cookie-banner__btn--accept"
            onClick={accept}
          >
            Accept all
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
